// ═══════════════════════════════════════════════════════════════════
// CONFIGURACIÓN CENTRAL — Cotizador Low Travel
// Modificar aquí para actualizar tarifas, destinos y parámetros.
// ═══════════════════════════════════════════════════════════════════

// ─── Moneda ─────────────────────────────────────────────────────────
export const MONEDA = "USD"

// ─── Configuración financiera ─────────────────────────────────────────
export const FDE                     = 20
export const COSTO_OP_POR_PERSONA    = 15
export const MARGEN_DEFAULT          = 15
// Si el privado supera al regular en ≤ este valor (USD), se prefiere el privado por comodidad
export const PRIVATE_PREMIUM_MAX_USD = 15

// ─── Orígenes ────────────────────────────────────────────────────────
export const ORIGEN_DEFAULT = "Buenos Aires"

export const ORIGENES = [
  { nombre: "Buenos Aires", olaCode: "281"  },
  { nombre: "Córdoba",      olaCode: "1088" },
  { nombre: "Mendoza",      olaCode: "2115" },
  { nombre: "Rosario",      olaCode: "2734" },
  { nombre: "Bariloche",    olaCode: "582"  },
  { nombre: "Salta",        olaCode: "2771" },
  { nombre: "Tucumán",      olaCode: "2835" },
]

// ─── Destinos turísticos ──────────────────────────────────────────────
// Cada destino tiene:
//   ola.aeropuerto → código IATA del aeropuerto utilizado en OLA
//   ola.code       → código numérico de OLA para construir el link
//   ola.options    → para destinos con múltiples aeropuertos (ej: Maragogi)
//   pn.slug        → slug de PriceNavigator
//   pn.id          → destinationId de PN (puede ser numérico o coordenada)
export const DESTINOS_COTIZADOR = [
  // ── GIG ──────────────────────────────────────────────────────────────
  {
    nombre: "Río de Janeiro",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "río-de-janeiro-brasil",   id: "5948"  },
  },
  {
    nombre: "Búzios",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "Buzios-Brasil",           id: "5798"  },
  },
  {
    nombre: "Arraial do Cabo",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "ArraialDoCabo,RioDeJaneiro,Brasil", id: "44112" },
  },
  {
    nombre: "Cabo Frío",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "CaboFrío-Brasil",         id: "5807"  },
  },
  {
    // NOTA: el destinationId de Barra de Tijuca es una coordenada, no un número
    nombre: "Barra de Tijuca",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "BarraTijuca-BarraDaTijuca,RíoDeJaneiro-EstadoDeRíoDeJaneiro,Brasil",
           id: "-23.0003709COORDINATES-43.365895" },
  },
  {
    nombre: "Angra dos Reis",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "AngraDosReis-Brasil",     id: "30158" },
  },
  {
    nombre: "Ilha Grande",
    ola: { aeropuerto: "GIG", code: "2695" },
    pn:  { slug: "IlhaGrande-IlhaGrande-Brasil", id: "41793" },
  },
  // ── FLN ──────────────────────────────────────────────────────────────
  {
    nombre: "Florianópolis",
    ola: { aeropuerto: "FLN", code: "1110" },
    pn:  { slug: "Florianópolis-Brasil",    id: "5826"  },
  },
  {
    nombre: "Balneario Camboriú",
    ola: { aeropuerto: "FLN", code: "1110" },
    pn:  { slug: "BalnearioCamboriu-Brasil", id: "30509" },
  },
  {
    nombre: "Bombinhas",
    ola: { aeropuerto: "FLN", code: "1110" },
    pn:  { slug: "Bombinhas-Brasil",        id: "31182" },
  },
  // ── REC ──────────────────────────────────────────────────────────────
  {
    nombre: "Porto de Galinhas",
    ola: { aeropuerto: "REC", code: "2668" },
    pn:  { slug: "PortoDeGalinhas-Brasil",  id: "13413" },
  },
  // ── MCZ / REC — Maragogi sin default asumido ─────────────────────────
  {
    nombre: "Maragogi",
    ola: {
      aeropuerto: null,   // sin default: el vendedor elige en el formulario
      options: [
        { aeropuerto: "MCZ", code: "62563", label: "Maceió (MCZ)" },
        { aeropuerto: "REC", code: "2668",  label: "Recife (REC)" },
      ],
    },
    pn: { slug: "Maragogi-Brasil", id: "30557" },
  },
  // ── MCZ ──────────────────────────────────────────────────────────────
  {
    nombre: "Maceió",
    ola: { aeropuerto: "MCZ", code: "62563" },
    pn:  { slug: "Maceio-Brasil",           id: "5859"  },
  },
  // ── NAT ──────────────────────────────────────────────────────────────
  {
    nombre: "Natal",
    ola: { aeropuerto: "NAT", code: "2242" },
    pn:  { slug: "Natal-Brasil",            id: "5866"  },
  },
  {
    nombre: "Pipa",
    ola: { aeropuerto: "NAT", code: "2242" },
    pn:  { slug: "Pipa-Brasil",             id: "30184" },
  },
  // ── SSA ──────────────────────────────────────────────────────────────
  {
    nombre: "Salvador de Bahia",
    ola: { aeropuerto: "SSA", code: "48717" },
    pn:  { slug: "SalvadorDeBahia-Brasil",  id: "5960"  },
  },
  // ── PUJ ──────────────────────────────────────────────────────────────
  {
    nombre: "Punta Cana",
    ola: { aeropuerto: "PUJ", code: "2624" },
    pn:  { slug: "PuntaCana-RepúblicaDominicana", id: "6128" },
  },
  {
    nombre: "Bayahibe",
    ola: { aeropuerto: "PUJ", code: "2624" },
    pn:  { slug: "Bayahibe-RepublicaDominicana",  id: "22543" },
  },
  {
    nombre: "Miches",
    ola: { aeropuerto: "PUJ", code: "2624" },
    pn:  { slug: "Miches-RepúblicaDominicana",    id: "83282" },
  },
  // ── CUN ──────────────────────────────────────────────────────────────
  {
    nombre: "Cancún",
    ola: { aeropuerto: "CUN", code: "852" },
    pn:  { slug: "Cancún-México",           id: "3703"  },
  },
  {
    nombre: "Playa del Carmen",
    ola: { aeropuerto: "CUN", code: "852" },
    pn:  { slug: "PlayaDelCarmen-México",   id: "3739"  },
  },
  // ── CTG ──────────────────────────────────────────────────────────────
  {
    nombre: "Cartagena",
    ola: { aeropuerto: "CTG", code: "883" },
    pn:  { slug: "Cartagena-Colombia",      id: "6061"  },
  },
]

// ─── PriceNavigator ──────────────────────────────────────────────────
export const PN_BASE_URL = "https://lowtravel.app.pricenavigator.net"

// Parámetros por defecto para TODAS las búsquedas de PN (decisión comercial)
export const PN_DEFAULT_PARAMS = {
  sort:             "price-asc",
  boards:           "2",
  favorites:        "true",
  freeCancellation: "true",
}

// ⚠️ PENDIENTE TÉCNICO — SEARCH_ID de PriceNavigator
// La URL completa de resultados requiere un ID generado por la plataforma:
//   /v3/hotels/results/{SEARCH_ID}/{SLUG}/{ID}/{CHECKIN}/{CHECKOUT}/{PAX}
// El SEARCH_ID cambia por sesión y no puede derivarse matemáticamente.
// Observamos IDs como: 01M35MHR1MNBE3S2YR77MJW1Z2
// Tarea futura: integrar el endpoint POST /v3/hotels-bff/rpc/hotels/search
// para obtener el searchId antes de construir la URL de resultados completa.
export const PN_SEARCH_ID = null

// ─── Tabla de tarifas de traslados ─────────────────────────────────────
// Fuente única de verdad: src/config/tarifas_traslados.json
// Importado directamente en cotizadorUtils.js
// Tipos de pricing:
//   "perPerson" → amount por persona, aplica del rango from a to
//   "group"     → amount fijo para el grupo, aplica del rango from a to
/*export const TARIFAS_TRASLADOS = [
  // GIG → destinos
  { origen:"GIG",             destino:"Río de Janeiro",    tipo:"privado", pricing:{ mode:"group",     from:1, to:4,  amount:50    }},
  { origen:"GIG",             destino:"Búzios",            tipo:"regular", pricing:{ mode:"perPerson", from:1, to:3,  amount:22    }},
  { origen:"GIG",             destino:"Búzios",            tipo:"privado", pricing:{ mode:"group",     from:4, to:4,  amount:100   }},
  { origen:"GIG",             destino:"Búzios",            tipo:"privado", pricing:{ mode:"group",     from:5, to:6,  amount:110   }},
  { origen:"GIG",             destino:"Arraial do Cabo",   tipo:"regular", pricing:{ mode:"perPerson", from:1, to:99, amount:35    }},
  { origen:"GIG",             destino:"Cabo Frío",         tipo:"regular", pricing:{ mode:"perPerson", from:1, to:99, amount:30    }},
  { origen:"GIG",             destino:"Barra de Tijuca",   tipo:"regular", pricing:{ mode:"perPerson", from:1, to:99, amount:22    }},
  { origen:"GIG",             destino:"Angra dos Reis",    tipo:"regular", pricing:{ mode:"perPerson", from:1, to:99, amount:40    }},
  { origen:"GIG",             destino:"Ilha Grande",       tipo:"regular", pricing:{ mode:"perPerson", from:1, to:99, amount:40    }},
  // Búzios → otros
  { origen:"Búzios",          destino:"Cabo Frío",         tipo:"privado", pricing:{ mode:"group",     from:1, to:4,  amount:55    }},
  { origen:"Búzios",          destino:"Cabo Frío",         tipo:"privado", pricing:{ mode:"group",     from:5, to:6,  amount:65    }},
  // FLN → destinos
  { origen:"FLN",             destino:"Florianópolis",     tipo:"privado", pricing:{ mode:"group",     from:1, to:3,  amount:37.5  }},
  { origen:"FLN",             destino:"Florianópolis",     tipo:"privado", pricing:{ mode:"group",     from:4, to:99, amount:76.5  }},
  { origen:"FLN",             destino:"Balneario Camboriú",tipo:"privado", pricing:{ mode:"group",     from:1, to:3,  amount:81    }},
  // PUJ → destinos
  { origen:"PUJ",             destino:"Punta Cana",        tipo:"privado", pricing:{ mode:"group",     from:1, to:3,  amount:15    }},
  { origen:"PUJ",             destino:"Bayahibe",          tipo:"privado", pricing:{ mode:"group",     from:1, to:3,  amount:90    }},
  { origen:"PUJ",             destino:"Miches",            tipo:"privado", pricing:{ mode:"group",     from:1, to:99, amount:null, noConfigurado:true }},
  // Maceió → Maragogi
  { origen:"Maceió",          destino:"Maragogi",          tipo:"regular", pricing:{ mode:"group",     from:1, to:2,  amount:120   }},
  { origen:"Maceió",          destino:"Maragogi",          tipo:"regular", pricing:{ mode:"group",     from:3, to:4,  amount:170   }},
  // MCZ → Maragogi
  { origen:"MCZ",             destino:"Maragogi",          tipo:"privado", pricing:{ mode:"group",     from:1, to:4,  amount:200   }},
  // Maceió ↔ MCZ (ciudad ↔ aeropuerto)
  { origen:"Maceió",          destino:"MCZ",               tipo:"privado", pricing:{ mode:"group",     from:1, to:2,  amount:31    }},
  { origen:"Maceió",          destino:"MCZ",               tipo:"privado", pricing:{ mode:"group",     from:3, to:4,  amount:37    }},
  // Recife → destinos
  { origen:"Recife",          destino:"Porto de Galinhas", tipo:"privado", pricing:{ mode:"group",     from:1, to:2,  amount:100   }},
  { origen:"Recife",          destino:"Porto de Galinhas", tipo:"privado", pricing:{ mode:"group",     from:3, to:3,  amount:102   }},
  { origen:"Recife",          destino:"Porto de Galinhas", tipo:"privado", pricing:{ mode:"group",     from:4, to:5,  amount:105   }},
  { origen:"Recife",          destino:"Maragogi",          tipo:"privado", pricing:{ mode:"group",     from:1, to:5,  amount:125   }},
  // Porto de Galinhas → Maragogi
  { origen:"Porto de Galinhas", destino:"Maragogi",        tipo:"privado", pricing:{ mode:"group",     from:1, to:2,  amount:91    }},
  { origen:"Porto de Galinhas", destino:"Maragogi",        tipo:"privado", pricing:{ mode:"group",     from:3, to:5,  amount:187   }},
  // Natal → destinos
  { origen:"Natal",           destino:"Pipa",              tipo:"privado", pricing:{ mode:"group",     from:1, to:4,  amount:85    }},
  { origen:"NAT",             destino:"Natal",             tipo:"privado", pricing:{ mode:"group",     from:1, to:4,  amount:39    }},
  // Salvador
  { origen:"Salvador de Bahia", destino:"Salvador de Bahia", tipo:"privado", pricing:{ mode:"group",  from:1, to:2,  amount:28    }},
  // CUN → destinos
  { origen:"CUN",             destino:"Playa del Carmen",  tipo:"regular", pricing:{ mode:"group",     from:1, to:2,  amount:45    }},
  { origen:"CUN",             destino:"Playa del Carmen",  tipo:"privado", pricing:{ mode:"group",     from:3, to:99, amount:90    }},
  // CTG → Cartagena
  { origen:"CTG",             destino:"Cartagena",         tipo:"privado", pricing:{ mode:"group",     from:1, to:3,  amount:26    }},
]*/